const baseUri = 'product-prices';

export default {
  create(data, cancelToken) {
    return api.post(`${baseUri}`, data, {
      cancelToken,
    });
  },
};



// WEBPACK FOOTER //
// ./src/js/api/productPrice.js